export var app: MyApp = null;
export const debug: boolean = true;

import { Scroll } from './components/scroll';
import { Menu, MenuState } from './components/menu';
import { Animations } from './components/animations';
import { AjaxHistory } from './components/ajax';
import { Bubble } from './components/bubble';
import { Accessbtn } from "./components/accessbtn";
import { Accordions } from './components/accordion';
import { Focustrap } from './components/focustrap';
import { VideoPlayback } from './components/video';
import PhotoSwipeLightbox from './plugins/photoswipe-lightbox.esm.js';
import PhotoSwipe from './plugins/photoswipe.esm.js';

document.addEventListener('DOMContentLoaded', () => {
    debug ? console.log('DOM loaded') : null;
    app = new MyApp();
    app.init();
});

window.addEventListener('load', () => {
    debug ? console.log('Window loaded') : null;
    app.showApp();
});

class MyApp {
    private menu: Menu;
    private animations: Animations;
    private preloader: HTMLElement = document.querySelector('.preloader');
    private ajaxHistory: AjaxHistory;
    public eventDispatcher: EventTarget = new EventTarget();
    public scroll: Scroll;
    public Bubble: Bubble;
    public Accessbtn: Accessbtn;
    public Focustrap: Focustrap;
    public videoPlayback: VideoPlayback;
    public accordions: Accordions;
    public browser: string;
    public mq: string;
    private photoswipeLightbox: PhotoSwipeLightbox;
    
    constructor() {      
        var self = this;

        this.detectBrowser();
        this.detectMQ();
        this.setSizeVars();

        this.Bubble = new Bubble();
        this.animations = new Animations();
        this.Accessbtn = new Accessbtn();
        this.Focustrap = new Focustrap();

        this.setPhotoswipe();

        window.addEventListener('resize', () => {
            this.detectMQ();
            this.setSizeVars();
        });
        
        this.menu = new Menu(
            document.querySelector('.menu-overlay') as HTMLElement,
            document.querySelector('.header-menu-toggle') as HTMLElement,
            document.querySelector('.menu-overlay-close') as HTMLElement
        );
        this.menu.addEventListener('menuStateChange', (event: CustomEvent) => {
            debug ? console.log('Menu state changed', event.detail) : null;
            if (event.detail === MenuState.Open) {
                self.eventDispatcher.dispatchEvent(new CustomEvent('menuOpened', { detail: event.detail}));
            }
            if (event.detail === MenuState.Closed) {
                self.eventDispatcher.dispatchEvent(new CustomEvent('menuClosed', { detail: event.detail}));
                document.querySelectorAll('.menu-overlay-bg')[0].setAttribute('data-selected', '');
            }
        });
        this.menu.addEventListener('mouseenter', (event: CustomEvent) => {
            // debug ? console.log('Menu link mouseenter', event.detail) : null;
            const dataIndex = event.detail.getAttribute('data-index');
            if (dataIndex) {
                const selectedIndex = parseInt(dataIndex);
                document.querySelectorAll('.menu-overlay-bg')[0].setAttribute('data-selected', `${selectedIndex}`);
            }
        });
 
        this.scroll = new Scroll();

        this.ajaxHistory = new AjaxHistory({ header: ".menu-overlay-items", footer: "footer", content: '#content' }, 500);
        this.ajaxHistory.addEventListener('fetchingPage', (event) => {
            debug ? console.log('Fetching page') : null;
            document.querySelector('html').classList.add('-loading');
        });
        this.ajaxHistory.addEventListener('pageFetched', (event: CustomEvent<{ url: string }>) => {            
            debug ? console.log('Fetching page success') : null;
            self.menu.closeMenu();
            self.menu.reinitialize();
            self.scroll.handleScrollTo(0);
            self.init();
            setTimeout(() => {
                document.querySelector('html').classList.remove('-loading');
            }, 500);
            self.eventDispatcher.dispatchEvent(new CustomEvent('changingPage', { detail: { url: event.detail.url } }));
        });
    }

    private setPhotoswipe(): void {
        this.photoswipeLightbox = new PhotoSwipeLightbox({
            gallery: '.gallery-ps',
            children: 'a',
            pswpModule: PhotoSwipe,
            initialZoomLevel: 'fit',
            secondaryZoomLevel: 1.5,
            showHideAnimationType: 'fade',
        });
        this.photoswipeLightbox.on('uiRegister', () => {
            this.photoswipeLightbox.pswp.ui.registerElement({
              name: 'caption-info-button',
              className: 'caption-info-button',
              ariaLabel: 'Show info about image',
              order: 9,
              isButton: true,
              appendTo: 'root',
              html: 'i',
              onClick: (event: any, el: any) => {
                let infoContainer = document.querySelector('.caption-info');
                if (!infoContainer) {
                  infoContainer = document.createElement('div');
                  infoContainer.classList.add('caption-info');
                  infoContainer.setAttribute('style', 'background-color: #fff; color: #FC491D;');
                  document.body.appendChild(infoContainer);
                }

                const closeButton = infoContainer.querySelector('.caption-info-close');

                const currSlideElement = this.photoswipeLightbox.pswp.currSlide.data.element;
                let contentHTML = '';

                if (currSlideElement) {
                  const hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');
                  const imgTitle = currSlideElement.getAttribute('data-title');
                  const imgDesc = currSlideElement.getAttribute('data-description');

                  if (hiddenCaption) {
                    contentHTML = hiddenCaption.innerHTML;
                  } else {
                    contentHTML = `<p class="caption-info-title">${imgTitle}</p><p class="caption-info-desc">${imgDesc}</p>`;
                  }
                }

                infoContainer.innerHTML = `
                    <span class="caption-info-close" onclick='document.querySelector(".caption-info").style.display = "none";'>x</span>
                    <div class="caption-info-wrapper">${contentHTML}</div>
                `;
                (infoContainer as HTMLElement).style.display = 'flex';
              }
            });
        });
    }

    private detectBrowser(): void {
        if (navigator.userAgent.indexOf("Chrome") != -1 ) {
            this.browser = "chrome";
        }
        else if (navigator.userAgent.indexOf("Firefox") != -1 ) {
            this.browser = "firefox";
        }
        else if (navigator.userAgent.indexOf("MSIE") != -1 ) {
            this.browser = "msie";
        }
        else if (navigator.userAgent.indexOf("Edge") != -1 ) {
            this.browser = "edge";
        }
        else if (navigator.userAgent.indexOf("Safari") != -1 ) {
            this.browser = "safari";
        }
        else if (navigator.userAgent.indexOf("Opera") != -1 ) {
            this.browser = "opera";
        }
        else if (navigator.userAgent.indexOf("YaBrowser") != -1 ) {
            this.browser = "yabrowser";
        }
        else {
            this.browser = "other";
        }
        document.documentElement.setAttribute('data-browser', this.browser);
    }

    private detectMQ(): void {
        this.mq = '';
        const tailwindConfig = require('../../../tailwind.config.js');
        const mediaQueries = Object.entries(tailwindConfig.theme.screens);

        for (const [key, value] of mediaQueries) {
            if (window.matchMedia(`(min-width: ${value})`).matches) {
                this.mq = key;
            }
        }
        document.documentElement.setAttribute('data-mq', this.mq);
    }

    private setSizeVars(): void {
        const hh: number | null = document.querySelector('.header')?.clientHeight;
        const fh: number | null = document.querySelector('.footer')?.clientHeight;
        
        document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
        hh ? document.documentElement.style.setProperty('--hh', `${hh}px`) : null;
        fh ? document.documentElement.style.setProperty('--fh', `${fh}px`) : null;
    }

    public init(): void {
        this.accordions = new Accordions();
        this.animations.initAnimations();
        for (const video of document.querySelectorAll('.video-box')) {   
            this.videoPlayback = new VideoPlayback(video.querySelector('.video-box-btn') as HTMLElement, video.querySelector('video') as HTMLVideoElement);
        }
        this.scroll.handleLiftUp(document.querySelectorAll('.scroll-up') as unknown as HTMLElement[]);
        this.photoswipeLightbox.init();
    }

    public showApp(): void {
        this.preloader.classList.add('-loaded');
    }
}